module.exports = __webpack_public_path__ + "img/logo_text.b943e74f.jpg";